<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import CompaniesModal from "@/components/Companies/CompaniesModal.vue";

export default {
    name: "VAutocompleteCompany",
    components: {
        CompaniesModal,
        AjaxLoad,
    },
    inheritAttrs: false,
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: undefined,
        },
    },
    methods: {
        onClickCompanies() {
            this.$refs.companiesModal.show()
                .then(response => {
                    const id = response?.id;
                    if (id) {
                        this.$emit('input', id);
                    }
                    if (response !== false) {
                        this.$refs.ajax.load();
                        this.$emit('updated');
                    }
                });
        },
    },
}
</script>

<template>
    <div>
        <ajax-load
            ref="ajax"
            :url="$apiUrl.getCompaniesUrl()"
            :transform="response => response.data.data"
            v-slot="{data, resolved}"
        >
            <v-autocomplete
                v-bind="$attrs"
                v-on="$listeners"
                :items="data"
                :loading="!resolved"
                :disabled="!resolved || disabled"
                :class="[$vnode.data.class, $vnode.data.staticClass]"
                label="Компания"
                item-text="name"
                item-value="id"
            >
                <template v-slot:append v-if="resolved && !disabled">
                    <div class="v-input__icon">
                        <v-icon @click.stop="onClickCompanies" @mousedown.stop>mdi-dots-horizontal</v-icon>
                    </div>
                    <div class="v-input__icon v-input__icon--append">
                        <v-icon>mdi-menu-down</v-icon>
                    </div>
                </template>
            </v-autocomplete>
        </ajax-load>

        <companies-modal
            ref="companiesModal"
            @dblclick:row="$emit('input', $event)"
        ></companies-modal>
    </div>
</template>

<style scoped lang="scss">

</style>
